import p from 'x/config/platform-specific'

const BarcodeScanner = p.comp.getBarcodeScanner()

export default BarcodeScanner
